import img_space from '@/assets/images/katsura-royal-collection.png';
import img_species from '@/assets/images/spring-bloom-collection.png';
import img_grade from '@/assets/images/summer-haze-collection.png';
import img_installation from '@/assets/images/winter-solace-collection.png';
import img_rooms from '@/assets/images/pages-aboutus-about-hero.png';

/**
 * Featured article teasers shared by the Flooring 101 (/academy/hardwood-basics) page and the
 * legacy Buying Guide page (/academy/buying-guide). Each item renders as a `guide-featured` section.
 */
export const buyingGuideArticles = [
  {
    label: 'Engineered vs. solid hardwood',
    title: 'Engineered Hardwood vs Solid Hardwood Flooring',
    excerpt:
      'One of the first decisions you’ll make when choosing hardwood flooring is whether to install engineered hardwood or solid hardwood. Although both feature genuine hardwood and offer timeless beauty, they are built differently and perform differently depending on the environment.',
    to: '/academy/buying-guide/engineered-vs-solid-hardwood',
    image: img_space,
    imageAlt: 'A bright living room showcasing hardwood flooring',
  },
  {
    label: 'Choosing wood species',
    title: 'Choosing Wood Species',
    excerpt:
      'Species is the foundation of a floor’s color, grain, and durability. From the warm familiarity of White Oak to the rich depth of Walnut, each species brings its own personality to a room.',
    to: '/academy/buying-guide/choosing-wood-species',
    image: img_species,
    imageAlt: 'Wide-plank hardwood flooring showing natural grain and character',
  },
  {
    label: 'Grade and character',
    title: 'Grade and Character',
    excerpt:
      'Grade describes how much natural variation appears across a floor — not the quality of the wood itself. Choosing the right grade is about matching the visual rhythm of a room to your personal style.',
    to: '/academy/buying-guide/grade-and-character',
    image: img_grade,
    imageAlt: 'A bright, minimal living room with uniform hardwood flooring',
  },
  {
    label: 'Installation considerations',
    title: 'Installation Considerations',
    excerpt:
      'The right installation method depends on your subfloor, moisture conditions, and how the space will be used. Getting installation right is just as important as choosing the right floor.',
    to: '/academy/buying-guide/installation-considerations',
    image: img_installation,
    imageAlt: 'A modern kitchen and living space with wide-plank hardwood flooring',
  },
  {
    label: 'Room selection',
    title: 'Choosing Hardwood Flooring Room by Room',
    excerpt:
      'Not every room places the same demands on a floor. See where engineered hardwood performs beautifully without a second thought, and where a little extra care — or a different material altogether — makes more sense.',
    to: '/academy/buying-guide/room-selection',
    image: img_rooms,
    imageAlt: 'A refined living room with hardwood flooring and a marble fireplace',
  },
];
